import { render, staticRenderFns } from "./OpenmarketFilterModal.vue?vue&type=template&id=350282f2&scoped=true"
import script from "./OpenmarketFilterModal.vue?vue&type=script&lang=js"
export * from "./OpenmarketFilterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350282f2",
  null
  
)

export default component.exports